'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/core-js/object/define-property');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _defineProperty4 = require('babel-runtime/helpers/defineProperty');

var _defineProperty5 = _interopRequireDefault(_defineProperty4);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _desc, _value, _class2, _descriptor, _descriptor2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _mobx = require('mobx');

var _Conversation = require('../../components/Conversation');

var _ScrollMonitor = require('../../components/ScrollMonitor');

var _ScrollMonitor2 = _interopRequireDefault(_ScrollMonitor);

var _patternMatchUtil = require('../../utils/patternMatchUtil');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty3.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

/**
 * Message container.
 */
var MessageContainer = (0, _mobxReact.observer)(_class = (_class2 = function (_React$Component) {
  (0, _inherits3.default)(MessageContainer, _React$Component);

  function MessageContainer() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, MessageContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MessageContainer.__proto__ || (0, _getPrototypeOf2.default)(MessageContainer)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'showDetails', _descriptor, _this), _initDefineProp(_this, 'toggleDetails', _descriptor2, _this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(MessageContainer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          message = _props.message,
          seenBy = _props.seenBy,
          group = _props.group,
          otherName = _props.otherName,
          onEnterViewport = _props.onEnterViewport,
          onDocumentClick = _props.onDocumentClick;

      var isLast = group.lastMessage.message === message;
      var messageElement = _react2.default.createElement(
        _Conversation.Message,
        {
          mine: group.mine,
          avatar: !group.mine && isLast ? message.sender.avatar : '',
          name: !group.mine && isLast ? otherName : '',
          seenBy: seenBy,
          receiptState: message.receiptState,
          onClick: message.type !== 'document' && this.toggleDetails,
          sentAt: this.showDetails && message.sentAt
        },
        (0, _patternMatchUtil.match)(message.type, (0, _defineProperty5.default)({
          text: function text() {
            return _react2.default.createElement(
              _Conversation.MessageBubble,
              null,
              message.text
            );
          },
          document: function document() {
            return _react2.default.createElement(_Conversation.MessageDocument, {
              fileName: message.document.fileName,
              title: message.document.label,
              subtitle: message.document.description,
              onClick: onDocumentClick
            });
          }
        }, _patternMatchUtil.match.DEFAULT, function () {
          return _react2.default.createElement(
            _Conversation.MessageBubble,
            null,
            '[Unknown message type "',
            message.type,
            '"]'
          );
        }))
      );
      return !onEnterViewport ? messageElement : _react2.default.createElement(
        _ScrollMonitor2.default,
        {
          enterViewport: function enterViewport() {
            return onEnterViewport();
          }
        },
        messageElement
      );
    }
  }]);
  return MessageContainer;
}(_react2.default.Component), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'showDetails', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'toggleDetails', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this2 = this;

    return function () {
      _this2.showDetails = !_this2.showDetails;
    };
  }
})), _class2)) || _class;

MessageContainer.propTypes = {
  message: _propTypes2.default.any,
  group: _propTypes2.default.any,
  onEnterViewport: _propTypes2.default.func,
  onDocumentClick: _propTypes2.default.func,
  otherName: _propTypes2.default.string,
  seenBy: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)])
};

exports.default = MessageContainer;
//# sourceMappingURL=MessageContainer.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/containers/ConversationContainer/MessageContainer.js
// module id = 626
// module chunks = 0